import React, { useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'

import { Toaster } from '@/components/base/toast'
import { TooltipProvider } from '@/components/base/tooltip'
import { AppI18nProvider } from '@/i18n/i18n-provider'
import { unsubscribeAll } from '@/utils/rx-utilities'

export default function RootProviders({ children }: { children: React.ReactNode }) {
	useEffect(() => {
		return () => {
			unsubscribeAll()
		}
	}, [])

	return (
		<TooltipProvider>
			<HelmetProvider>
				<AppI18nProvider>
					{children}
					<Toaster />
				</AppI18nProvider>
			</HelmetProvider>
		</TooltipProvider>
	)
}
